// Curated entry points reference canonical portfolio evidence; they do not fork it.
const roleFamilies = [
  {
    slug: "maintenance-reliability",
    label: "Maintenance & reliability leadership",
    headline: "Frontline leadership for automated manufacturing",
    intro:
      "My core experience is leading maintenance teams, troubleshooting production equipment, and coordinating maintenance execution. Maintenance systems and software literacy support that work.",
    description:
      "Maintenance leadership, automated manufacturing, and equipment qualification evidence from Zacharia Lentz. Open to Michigan-based and remote opportunities.",
    credibilityLabels: ["Team scope", "Operations", "Leadership depth"],
    caseStudyIds: [
      "maintenance-leadership",
      "equipment-qualification",
      "cmms-administration",
    ],
    supportingStudyIds: ["industrial-operations-intelligence"],
    experienceIds: ["tesla-supervision", "marine-maintenance"],
    backgroundTitle: "Industrial leadership with a safety-critical foundation",
    contactPrompt:
      "Discuss maintenance or technical operations leadership opportunities in Michigan, or remote roles that draw on that experience.",
  },
  {
    slug: "maintenance-systems",
    label: "Maintenance systems & CMMS",
    headline: "Maintenance systems grounded in frontline work",
    intro:
      "I administer CMMS configuration while leading the people who use it. That perspective connects preventive-maintenance planning, practical workflows, and useful maintenance information.",
    description:
      "Zacharia Lentz's CMMS administration and maintenance workflow evidence for Michigan-based and remote roles. Relocating to the Midland, Michigan area.",
    credibilityLabels: ["Systems", "Team scope", "Operations"],
    caseStudyIds: [
      "cmms-administration",
      "industrial-operations-intelligence",
      "maintenance-leadership",
    ],
    supportingStudyIds: [],
    experienceIds: ["tesla-supervision"],
    backgroundTitle: "Configuration decisions informed by daily maintenance",
    showDemonstration: true,
    contactPrompt:
      "Discuss Michigan-based or remote opportunities in maintenance systems, CMMS, or maintenance process improvement.",
  },
  {
    slug: "industrial-technology",
    label: "Industrial technology & product delivery",
    headline: "Factory-floor knowledge that informs technical delivery",
    intro:
      "I translate maintenance pain points into requirements and supervisor workflows. Equipment qualification, customer-facing field service, and software-development training give that product thinking an operational foundation.",
    description:
      "Factory-floor expertise, workflow design, and technical delivery evidence from Zacharia Lentz for Michigan-based and remote opportunities.",
    credibilityLabels: ["Operations", "Systems", "Foundation"],
    caseStudyIds: [
      "industrial-operations-intelligence",
      "equipment-qualification",
      "cmms-administration",
    ],
    supportingStudyIds: ["maintenance-leadership"],
    experienceIds: ["field-service"],
    backgroundTitle: "Customer-facing technical experience",
    positioningNote:
      "My core experience is industrial maintenance and technical leadership. My software contribution combines workflow and UI decisions with reviewed, tested AI-assisted implementation, supported by software-development training.",
    contactPrompt:
      "Discuss Michigan-based or remote roles in industrial technology, implementation, or technical product delivery.",
  },
];

export { roleFamilies };
